<div class="modal-body bg-primary text-white">
	<div class="d-flex justify-content-between align-items-center mx-2">
		<div class="mr-3"><strong>New version of Service Portal is available.</strong></div>
		<button class="btn btn-sm btn-light" (click)="onReload()">Update ({{ seconds }})</button>
	</div>
</div>
